import React from 'react';

import { RegistrationQuizStep, SelectNumberOption, SelectOption } from 'types';

import css from './singleSelect.module.sass';

type Props = {
  options: SelectOption[] | SelectNumberOption[];
  currentStep: RegistrationQuizStep;
  selectedAnswers: number[];
  optionsSmiles?: string[];
  handleChange: (name: string, value: number) => void;
};

export const SingleSelect: React.FC<Props> = React.memo(
  ({ options, currentStep, selectedAnswers, optionsSmiles, handleChange }) => {
    return (
      <div className={css.root}>
        {options.map((option, index) => (
          <div
            key={option.value}
            className={css.option}
            onClick={() => handleChange(currentStep.name, +option.value)}
          >
            <div className={css.selected}>
              {selectedAnswers.includes(+option.value) && (
                <div className={css.selectedBadge} />
              )}
            </div>
            <p className={css.text}>
              {(!!optionsSmiles && optionsSmiles?.[index]) || ''} {option.label}
            </p>
          </div>
        ))}
      </div>
    );
  }
);
